import ArticleCard from '@/components/base/ArticleCard';
import { getFeaturedArticles } from '@/mocks/articles';

export default function NewsSection() {
  const featuredArticles = getFeaturedArticles();

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
              最新资讯
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg">
              获取金沙娱乐最新动态、游戏攻略、优惠信息和行业资讯。
            </p>
          </div>
          <a
            href="#"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap"
          >
            查看全部
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {featuredArticles.map((article, index) => (
            <ArticleCard
              key={article.id}
              article={article}
              variant={index === 0 ? 'featured' : 'default'}
            />
          ))}
        </div>
      </div>
    </section>
  );
}